// Code generated by @hex-insights/frontend-generator; While this comment is present this file may be overwritten. If manual edits are made, remove this comment.
import { IndexForms } from "@hex-insights/app-modules";

export const registry = new IndexForms.AdvancedFilterInformationRuntimeRegistry();
